import { put, select } from "redux-saga/effects";
import importer from "common/importer";
const LoyaltyDonorActions = importer("Stores/Loyalty/Actions");
const { getLoyaltyActivity } = importer("APIs/loyalty", null);
const { tokens } = importer("Stores/Users/Select", null);

export default function* main({ pdn }) {
  try {
    const _tokens = yield select(tokens);
    const { token_type, id_token } = _tokens;
    const token = `${token_type} ${id_token}`;
    yield put(LoyaltyDonorActions.getLoyaltyActivityLoading());
    const loyaltyActivityResponse = yield getLoyaltyActivity(pdn, token);
    const sortedTransactions = loyaltyActivityResponse.data.transactions.sort(
      (firstTransaction, secondTransaction) =>
        new Date(secondTransaction.activityDate).getTime() -
        new Date(firstTransaction.activityDate).getTime()
    );
    const successData = {
      expirationDetails: loyaltyActivityResponse.data.expirationDetails,
      transactions: sortedTransactions,
    };
    yield put(LoyaltyDonorActions.getLoyaltyActivitySuccess(successData));
  } catch (error) {
    yield put(LoyaltyDonorActions.getLoyaltyActivityFailure(error));
  }
}
